const AGR_SUFFIX = "_agr";

export interface AgrTicker {
  readonly base: string;
  readonly kind: "parent" | "child";
}

export function parseAgrTicker(raw: string): AgrTicker {
  return raw.endsWith(AGR_SUFFIX)
    ? { base: raw.slice(0, -AGR_SUFFIX.length), kind: "child" }
    : { base: raw, kind: "parent" };
}

export function toRawTicker(ticker: AgrTicker): string {
  return ticker.kind === "child" ? `${ticker.base}${AGR_SUFFIX}` : ticker.base;
}

export function isAgrTicker(raw: string): boolean {
  return raw.endsWith(AGR_SUFFIX);
}

export function parentTickerOf(raw: string): string {
  return isAgrTicker(raw) ? raw.slice(0, -AGR_SUFFIX.length) : raw;
}

export function childTickerOf(raw: string): string {
  return isAgrTicker(raw) ? raw : `${raw}${AGR_SUFFIX}`;
}
